import { inject } from 'dependable-react';
import camelCase from 'lodash/camelCase';
import { APP_DATA_TOKEN, I18N_TOKEN } from './InjectTokens';
export class TranslationsService {
  private appState = inject(APP_DATA_TOKEN);
  private i18n = inject(I18N_TOKEN);

  public get(page: number, contentString: string, variables?: Record<string, any>) {
    const configs = this.getConfigs(page);
    const contentKeys = configs
      .filter(Boolean)
      .filter((c: any) => c.contents)
      .map((c: any) => c.contents.map(camelCase));
    const regex = new RegExp(`contentP${page}E\\d{0,}${contentString}`);
    const keys = contentKeys.map((keyArr) => {
      const matched = keyArr.find((k: string) => k.match(regex));

      if (matched) {
        return matched;
      }

      return keyArr.find((k: string) => k.toLowerCase().includes('default'));
    });

    // To support overriding dedication variable for new lines
    const modifiedVariables: Record<string, any> = { ...variables };

    if (modifiedVariables.dedication) {
      modifiedVariables.dedication = modifiedVariables.dedication.replace(/\n/g, '<br />');
    }

    return keys.map((key) => ({
      barcodes: this.getBarcodes(configs),
      configs: this.getConfig(configs, key),
      images: this.getImages(configs),
      text: this.i18n.t(key, modifiedVariables),
    }));
  }

  private getConfigs(page: number) {
    const configuration = this.appState.configuration[this.appState.currentLanguage];
    const regex = new RegExp(`configuration(P${page})E\\d`);
    const keys = Object.keys(configuration).filter((k) => k.match(regex));

    return keys.map((k) => configuration[k]);
  }

  private getConfig(configs: any, key: string) {
    return configs.filter(Boolean).find((cfg: any) => {
      if (!cfg.contents) {
        return false;
      }

      return cfg.contents.map(camelCase).includes(key);
    });
  }

  private getImages(configs: any) {
    return configs.filter(Boolean).filter((cfg: any) => cfg.type === 'image');
  }

  private getBarcodes(configs: any) {
    return configs.filter(Boolean).filter((cfg: any) => cfg.type === 'barcode');
  }
}
